<template>
  <div class="main">
    <div id="profilo-box" v-if="!showForm">
      <div class="profile-image-container">
        <RdsFileUploader v-on:fileUploaded="onFileUploaded"></RdsFileUploader>
        <HomeProfile v-bind:isCurrentUser="isCurrentUser" v-bind:user="user"></HomeProfile>
      </div>

      <!-- <div id="section-nav">
        <div v-on:click="changeTab(0)" v-bind:class="{ selected: tab == 0}">
          <p>{{tab0}}</p>
        </div>
        <div v-on:click="changeTab(1)" v-bind:class="{ selected: tab == 1}">
          <p>{{tab1}}</p>
        </div>
         <div v-on:click="changeTab(2)" v-bind:class="{ selected: tab == 2}">
          <p>{{tab2}}</p>
        </div>
      </div>-->
      <ExperienceCard
        v-bind:isCurrentUser="isCurrentUser"
        v-bind:profile="user.experience"
        v-if="this.tab == 0"
      ></ExperienceCard>
      <ProfileCard
        v-bind:isCurrentUser="isCurrentUser"
        v-bind:contacts="user.contacts"
        v-bind:info="user.info"
        v-bind:skills="user.skills"
        v-if="this.tab == 1"
      ></ProfileCard>
      <ExperienceCard
        v-bind:isCurrentUser="isCurrentUser"
        v-bind:profile="user.education"
        v-if="this.tab == 2"
      ></ExperienceCard>
    </div>
    <transition name="slide-top" mode="out-in">
      <ProfileForm
        v-on:profileSaved="profileSaved"
        v-bind:user="userService.user"
        v-if="!!showForm"
      ></ProfileForm>
    </transition>
  </div>
</template>
<script>
// import mocker from '../services/Mocker.service';
import ProfileCard from '../components/ProfileCard';
import HomeProfile from '../components/HomeProfile';
import ExperienceCard from '../components/ExperienceCard';
import ProfileForm from '../components/ProfileForm';
import RdsFileUploader from '../components/RdsFileUploader';
import userService from '../services/User.service';
import { eventBus } from '../services/EventBus';
import store from '../stores';
import memoryStore from '../stores/MemoryStore';

export default {
  name: 'profile',
  components: {
    HomeProfile,
    ProfileCard,
    ExperienceCard,
    ProfileForm,
    RdsFileUploader
  },
  data() {
    return {
      tab: 1,
      // user: user,
      userService: userService,
      tab0: 'Esperienza',
      tab1: 'Profilo',
      // tab2: 'Formazione',
      showForm: false,
      otherUser: null
    };
  },
  methods: {
    onFileUploaded(file) {
      if (this.$route.name === 'editImage' || this.$route.name === 'home') {
        eventBus.$emit('hideMenuProfile');
        eventBus.$emit('editMode', file);
      }
      memoryStore.editableImage = file;
      console.log('SET memoryStore.editableImage');
      this.$router.push('/edit-image');
    },
    changeTab(tab) {
      console.log(userService.user);
      console.log(this.userService.user.contacts);
      this.tab = tab;
    },
    backButtonClicked() {
      console.log('PROFILE: backButtonClicked');
      // eventBus.$emit('showPlusButton');
      eventBus.$emit('hideBackButton');
      this.showForm = false;
    },
    plusButtonClicked() {
      console.log('PROFILE: plusButtonClicked');
      eventBus.$emit('hidePlusButton');
      eventBus.$emit('showBackButton');
      this.showForm = true;
    },
    profileSaved(user) {
      // eventBus.$emit('showPlusButton');
      eventBus.$emit('hideBackButton');
      eventBus.$emit('updating');
      store
        .update('rdsUser', user.id, user)
        .then(u => {
          userService.user = u;
          eventBus.$emit('updated');
          this.showForm = false;
        })
        .catch(e => {
          console.warn(e);
          eventBus.$emit('updated');
        });
    }
  },
  computed: {
    user() {
      return this.otherUser || this.userService.user;
    },
    isCurrentUser() {
      console.log('isCurrentUser', !this.otherUser);
      return !this.otherUser;
    }
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      this.backButtonClicked();
    });
    eventBus.$on('plusButtonClicked', () => {
      this.plusButtonClicked();
    });
    // eventBus.$emit('showPlusButton');
  },
  destroyed() {
    eventBus.$emit('hidePlusButton');
    eventBus.$emit('hideBackButton');
    eventBus.$off('backButtonClicked');
    eventBus.$off('plusButtonClicked');
  },
  mounted() {
    const userId = this.$route.query.user;
    if (!!userId) {
      store.get('rdsUser', userId).then(u => {
        this.otherUser = u;
      });
    }

    if (this.$route.name === 'editProfile') {
      this.plusButtonClicked();
    }
  }
};
</script>
<style lang="scss">
#profilo-box #header-profilo {
  position: relative;
}

#profilo-box #header-profilo #profilo {
  width: 100%;
}

#profilo-box #header-profilo #more {
  width: 33px;
  position: absolute;
  top: 48px;
  right: 85px;
}

#profilo-box #section-nav {
  position: sticky;
  top: 0;
  width: 100%;
  // height: 107px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  font-weight: 600;
  & > div {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      width: 0;
      border-bottom: 2px solid #a31316;
      transition: all 0.2s linear;
      bottom: 0;
      left: 0;
    }
  }
  & > div.selected {
    color: black;
    &:after {
      width: 100%;
      transform: translateX(0);
    }
  }
  p {
    margin: 0;
    padding: 20px;
  }
}

#profilo-box #section-nav div {
  width: calc(100% / 2);
  color: rgba(0, 0, 0, 0.4);
  // height: 117px;
  // line-height: 124px;
}

#profilo-box #inner-section-container {
  padding: $default-padding;
  // margin-bottom: 100px;
}

#profilo-box #inner-section-container .single-section .box {
  background: #ffffff;
  border-radius: $default-border-radius;
  display: flex;
  align-items: center;
  box-shadow: 0pt 6pt 12pt rgba(0, 0, 0, 0.05);
  justify-content: space-between;
}
#profilo-box #inner-section-container .single-section .title-box {
  border-radius: 5px 5px 0 0;
}
#profilo-box #inner-section-container .single-section .description-box {
  border-radius: 0 0 5px 5px;
}

#profilo-box #inner-section-container .single-section .title-box {
  margin-bottom: 10px;
  font-weight: 600;
}

// #profilo-box #inner-section-container .single-section .title-box img {
//   width: 21px;
// }

#profilo-box #inner-section-container .single-section .description-box {
  flex-direction: column;
  align-items: baseline;
  // line-height: 45px;
}

#profilo-box #inner-section-container .single-section .description-box p span {
  font-weight: 600;
}
.profile-image-container {
  position: relative;
}
</style>
